import * as React from 'react';
import CardEnumOptions from '../Shared/CardEnumOptions';
import CheckboxValidation from '../Shared/CheckboxValidation';

function getRandomId() {
  const chars = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];
  const numberOfChars = chars.length;
  const randomIdLength = 50;

  return Array.from({ length: randomIdLength })
    .map(() => chars[Math.floor(Math.random() * numberOfChars)])
    .join('');
}

export function MultipleChoice({ parameters, onChange }) {
  const enumArray = Array.isArray(parameters.items.enum)
    ? parameters.items.enum
    : [];

  const [elementId] = React.useState(getRandomId());

  const handleCardEnumOptionsChange = (newEnum, newNames, altTexts) => {
    // Propagate the updated enum and enumNames upwards
    return onChange({
      ...parameters,
      items: {
        enum: newEnum,
        enumNames: newNames,
        altTexts: altTexts,
        type: 'string',
      },
    });
  };

  return (
    <div className="card-enum">
      <h3>Possible Values</h3>
      <CheckboxValidation
        onChangeValue={() => {
          if (parameters?.minItems !== 1) {
            onChange({
              ...parameters,
              minItems: 1,
            });
          } else {
            onChange({
              ...parameters,
              minItems: 0,
            });
          }
        }}
        isChecked={parameters?.minItems === 1 ? true : false}
        label="At least 1 item is required (used instead of Required checkbox)"
        id={`${elementId}_min`}
      />
      <CheckboxValidation
        onChangeValue={() => {
          if (parameters.showOther) {
            onChange({
              ...parameters,
              showOther: false,
            });
          } else {
            onChange({
              ...parameters,
              showOther: true,
            });
          }
        }}
        isChecked={parameters.showOther}
        label="Add an other option with text(required)"
        id={`${elementId}_other`}
      />
      <CheckboxValidation
        disabled={true}
        onChangeValue={() => {
          if (parameters.hasContingentCheckboxes !== 1) {
            onChange({
              ...parameters,
              hasContingentCheckboxes: 1,
            });
          } else {
            onChange({
              ...parameters,
              hasContingentCheckboxes: 0,
            });
          }
        }}
        isChecked={parameters.hasContingentCheckboxes === 1 ? true : false}
        label="Has contingent checkboxes?"
        id={`${elementId}_contingent_checkboxes`}
      />
      <CheckboxValidation
        onChangeValue={() => {
          if (parameters.hasOutcome !== 1) {
            onChange({
              ...parameters,
              hasOutcome: 1,
              items: {
                type: 'string',
                enum: parameters.items.enumNames,
                enumNames: parameters.items.enumNames,
              },
            });
          } else {
            onChange({
              ...parameters,
              hasOutcome: 0,
              items: {
                type: 'string',
                enum: parameters.items.enumNames,
                enumNames: parameters.items.enumNames,
              },
            });
          }
        }}
        isChecked={parameters.hasOutcome === 1 ? true : false}
        label="Has an Outcome?"
        id={`${elementId}_outcome`}
      />
      <CardEnumOptions
        initialValues={enumArray}
        names={
          Array.isArray(parameters.items.enumNames)
            ? parameters.items.enumNames.map(val => `${val}`)
            : undefined
        }
        altTexts={parameters.items.altTexts}
        showNames={Array.isArray(parameters.items.enumNames)}
        showOther={parameters.showOther}
        hasContingentCheckboxes={parameters.hasContingentCheckboxes}
        contingentItems={parameters.contingentItems}
        hasOutcome={parameters.hasOutcome}
        hasAltText={parameters.enableAltText} // Whether there is an AltText or not for the Card Enum
        onChange={handleCardEnumOptionsChange}
        onDelete={index => {
          var contingentItems = parameters.contingentItems || {};
          var prop = 'c' + index;
          if (contingentItems.hasOwnProperty(prop)) {
            delete contingentItems[prop];
            for (
              var innerIndex = index + 1;
              innerIndex < Object.keys(parameters.contingentItems).length + 1;
              innerIndex++
            ) {
              var innerProp = 'c' + innerIndex;
              if (contingentItems.hasOwnProperty(innerProp)) {
                contingentItems['c' + (innerIndex - 1)] =
                  contingentItems[innerProp];
                delete contingentItems[innerProp];
              }
            }

            return onChange({
              ...parameters,
              contingentItems,
            });
          }
        }}
        onContingentChange={(index, newEnum) => {
          newEnum = newEnum || 'option 1';
          var contingentItems = parameters.contingentItems || {};
          var prop = 'c' + index;
          contingentItems[prop] = newEnum;
          return onChange({
            ...parameters,
            contingentItems,
          });
        }}
      />
    </div>
  );
}

// specify the inputs required for a string type object
export function CardDefaultParameterInputs({ parameters, onChange }) {
  return <div />;
}
